import { IPageActions } from '@chess-class/sandbox';

enum IChaptersPageActionsEnum {
  'view',
  'rate',
}

enum IChaptersPageActionTypesEnum {
  'test',
  'exercise',
}

export type IExercisePageActions = {
  action: keyof typeof IChaptersPageActionsEnum;
  actionId: string;
  actionType: keyof typeof IChaptersPageActionTypesEnum;
};

export const exercisePageActions: IPageActions<IExercisePageActions> = {
  action: {
    allowed: (value) => Object.keys(IChaptersPageActionsEnum).includes(value),
    default: '',
  },
  actionId: { default: '' },
  actionType: { default: '' },
};
